import { render, staticRenderFns } from "./MinutesDashboardModal.vue?vue&type=template&id=1dcf2d54&"
import script from "./MinutesDashboardModal.vue?vue&type=script&lang=js&"
export * from "./MinutesDashboardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports